import * as React from "react";
import { OnSaveSettings, UpdateType, useColumnResize, useScale, useSorting, useViewOnSaveSettings, Views } from '../../../store/services/viewSaver';
import { IWithSubViews, IWithSortBy, IWithScale, ISortState, ISortingProps } from '../../../entities/common';
import { TimelineChange } from "../../common/timeline/TimelineList";
import WorkloadGrid, { OwnProps } from "./WorkloadGrid";
import { ITimelineProps } from "../../common/extensibleEntity/EntityTimelineList";
import { IListProps } from "../../common/extensibleEntity/EntityDetailsList";
import { IWithTimeType } from "./common";

export type ResourceUsageGridSettings = IWithSubViews & IWithSortBy & IWithScale & IWithTimeType;

export type OnUsageGridSaveSettings = OnSaveSettings<UpdateType | 'TimeType'>;

type Props = {
    controlSettings: ResourceUsageGridSettings;
    onSaveSettings?: OnUsageGridSaveSettings;
    defaultSort?: ISortState;
    onScaleChanged: (timelineChange: TimelineChange) => void;
}
export const PersistWorkloadGrid = (props: Omit<OwnProps, 'timeType' | "onTimeTypeChange" | "listProps"> & Props) => {
    const { controlSettings, defaultSort, onScaleChanged } = props;

    const onSaveSettings = useViewOnSaveSettings(Views.Usage, props.onSaveSettings);
    const saverProps: Partial<IListProps> & Partial<ITimelineProps> = {
        ...useColumnResize(controlSettings.usage, onSaveSettings),
        ...useScale(controlSettings.usage, onSaveSettings, onScaleChanged),
        sorting: useSorting(controlSettings.usage, onSaveSettings, defaultSort) as ISortingProps,
    }

    return <WorkloadGrid
        {...props}
        listProps={saverProps}
    />;
}
